export const locale = {
    lang: 'tr',
    data: {
        'NAV': {
            'APPLICATIONS': 'Programlar',
            'DASHBOARDS'  : 'Kontrol Paneli',
            'ECOMMERCE'   : 'E-Ticaret',
            'ACADEMY'     : 'Akademi',
            'MAIL'        : {
                'TITLE': 'Posta',
                'BADGE': '15'
            },
            'MAIL_NGRX'        : {
                'TITLE': 'Posta Ngrx',
                'BADGE': '13'
            },
            'CHAT'        : 'Sohbet',
            'FILE_MANAGER': 'Dosya Yöneticisi',
            'CONTACTS'    : 'Kişiler',
            'TODO'        : 'Yapılacaklar',
            'SCRUMBOARD'  : 'Proje'
        }
    }
};



// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/navigation/i18n/tr.ts